const redirectNotFound = (to, from, next) => {
  if (to.name === 'Blank') {
    console.log('blank')
    if (from.name !== 'Notfound') {
      console.log('blank2')
      next({ name: 'Notfound' })
    } else {
      next(false) // หยุดการเปลี่ยนเส้นทางถ้าอยู่ในหน้าเดียวกัน
    }
  } else {
    next()
  }
}

export {
  redirectNotFound
}
